module.exports = __webpack_public_path__ + "static/partnership_img4@2x-e89cbf5bc0baf334445cb1cfa00232b2.jpg";